<template>
  <div class="dashboard-header">
    <div class="logo-box">
          <!-- <img src="https://asset.aditi.com.kh/images/logo/6350fb1789751.png" alt="Logo"   class="img-fluid logo "> -->
          <img :src="logoUrl" alt="Logo" class="img-fluid logo ">
        </div>

    <div class="info-card">
      <div class="info-item">
        <div class="icon-circle red-icon large-variant">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
           >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div class="info-text">
          <h1 class="value">{{ currentTime }}</h1>
          <p class="label">Current Time</p>
        </div>
      </div>

      <div class="info-item">
        <div class="icon-circle blue-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"
            />
          </svg>
        </div>
        <div class="info-text">
          <h1 class="value">{{ weather.temp }}°C</h1>
          <p class="label">{{ weather.condition }}</p>
        </div>
      </div>

      <div class="info-item">
        <div class="icon-circle red-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
            />
          </svg>
        </div>
        <div class="info-text">
          <h1 class="value">{{ occupancy.current }} / {{ occupancy.total }}</h1>
          <p class="label">In Office</p>
        </div>
      </div>

      <div class="info-item">
        <div class="icon-circle green-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h1.75c.621 0 1.125.504 1.125 1.125V21"
            />
          </svg>
        </div>
        <div class="info-text">
          <h1 class="value green-text">{{ status.text }}</h1>
          <p class="label">Office Status</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoreLibrary from "../../../core/helpers/CoreLibrary";
import { mapActions, mapState } from "vuex";
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {PUBLIC_DASHBOARD} from "../../../tenant/Config/ApiUrl";

export default {
  name: "TopBar",
  extends: CoreLibrary, // Keeping your extension
  props: {
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    officeStatus: {
      type: String,
      default: "Open",
    },
    logoUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logoUrl : this.logoUrl,
      // --- Your Existing Data ---
      user: {},
      workShiftModal: false,
      // --- New Dashboard Data ---
      currentTime: "",
      timerInterval: null, // To store the timer ID so we can clear it later
      weatherInterval: null, // To store the weather timer ID
      dataInterval: null,
      weather: { 
          temp: 0, 
          condition: 'Loading...',
          icon: 'loader' // Default icon while loading
      },
      occupancy: {
        current: this.current,
        total: this.total,
      },
      status: {
        text: this.officeStatus,
      },
      index: 0,
    };
  },
  computed: {
    ...mapState({
      languages: (state) => state.support.languages,
    }),
    userLanguage() {
      if (window.appLanguage) {
        return window.appLanguage.toUpperCase();
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["getLanguages"]),

    // --- New Method for Clock ---
    updateTime() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },

    getData() {
      axiosGet(`${PUBLIC_DASHBOARD}/header-status`).then(({data}) => {
        this.occupancy = {
            current: data.employees_in_office,
            total: data.total_employees
        };
        this.status = {
            text: data.office_status
        };
      });
    },

    async getPhnomPenhWeather() {
      const weatherConfig = {
          0: { text: "Sunny", icon: "sun" },
          1: { text: "Mainly Clear", icon: "sun" },
          2: { text: "Partly Cloudy", icon: "cloud" },
          3: { text: "Overcast", icon: "cloud" },
          45: { text: "Foggy", icon: "cloud-drizzle" },
          48: { text: "Rime Fog", icon: "cloud-drizzle" },
          51: { text: "Light Drizzle", icon: "cloud-drizzle" },
          61: { text: "Slight Rain", icon: "cloud-rain" },
          63: { text: "Rain", icon: "cloud-rain" },
          80: { text: "Rain Showers", icon: "cloud-lightning" },
          95: { text: "Thunderstorm", icon: "zap" }
      };
      try {
          const url = "https://api.open-meteo.com/v1/forecast?latitude=11.551989&longitude=104.886849&current=temperature_2m,weather_code";
          const { data } = await axios.get(url);
          const code = data.current.weather_code;
          const config = weatherConfig[code] || { text: "Clear", icon: "sun" };
          console.log(config);
          this.weather = {
            temp: Math.round(data.current.temperature_2m),
            condition: config.text,
            icon: config.icon
          };
      } catch (error) {
          console.error("Could not fetch Phnom Penh weather", error);
      }
  }
  },
  created() {
    // this.getLanguages();
  },
  mounted() {
    // Start the clock immediately when component mounts
    this.updateTime();
    this.timerInterval = setInterval(this.updateTime, 1000);

    // Fetch weather data when component mounts
    this.getPhnomPenhWeather();
    this.weatherInterval = setInterval(this.getPhnomPenhWeather, 60 * 1000); // Update weather every minute

    this.getData();
    this.dataInterval = setInterval(this.getData, 60 * 1000);
  },
  beforeDestroy() {
    // Clean up the timer when leaving the page to prevent memory leaks
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.weatherInterval) {
      clearInterval(this.weatherInterval);
    }
    if (this.dataInterval) {
      clearInterval(this.dataInterval);
    }
  },
};
</script>
<style scoped>
.dashboard-header {
  font-family: "Inter", sans-serif;
  background-color: #f8f9fa;
  padding: 10px 15px; /* Adjusted padding */
  display: flex; /* Make it a flex container */
  align-items: center; /* Vertically align items */
  justify-content: space-between; /* Space out logo and info-card */
}
.logo-box{
  display: flex;
}
.container{
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
}

.logo {
  max-width: 130px; /* Controlled logo size */
  height: auto;
}

.info-card {
  background-color: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  
  /* Changed to Grid for 4 columns */
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  align-items: center;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;  
  min-width: 150px; 
  justify-content: center;
  }

/* Added Media Query for dashboard-header */
@media only screen and (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start; /* Align logo to left when stacked */
  }
}

/* Reduced Icon Sizes */
.icon-circle {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}

.icon-circle svg {
  width: 38px;
  height: 38px;
}

/* Significantly smaller text as requested */
.info-text .value {
  margin: 0;
  font-size: 1.6rem; /* Was 2rem */
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.info-text .label {
  margin: 0;
  font-size: 0.8rem; /* Was 1.5rem */
  color: #6b7280;
}

.red-icon { color: #b91c1c; }
.blue-icon { color: #3b82f6; }
.green-icon { color: #10b981; }
.green-text { color: #10b981 !important; }

@media only screen and (max-width: 1024px) {
  .info-card {
     grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

 

/* Responsive Media Queries */
@media only screen and (max-width: 768px){
  .info-card {
    display: grid;
    grid-template-columns: 1fr 1fr; /* 2x2 grid on tablets */
    padding: 15px;
  }
  /* Significantly smaller text as requested */
.info-text .value {
   font-size: 1.2rem; /* Was 2rem */
 }
 /* Reduced Icon Sizes */
.icon-circle {
  width: 30px;
  height: 30px;
 }

.icon-circle svg {
  width: 30px;
  height: 30px;
}
}

@media only screen and (max-width: 480px) {
  .info-card {
    grid-template-columns: 1fr; /* 1 column on phones */
    gap: 15px;
  }
  
  .dashboard-header {
    padding: 10px;
  }
  
}
</style>
